import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AOS from "aos";
import { jwtDecode } from "jwt-decode";
import { getHomeSixSecData } from '../../../Redux/action/MasterAction';
import { useDispatch, useSelector } from 'react-redux';
import Aos from 'aos';


const host = process.env.REACT_APP_API_SERVER
const ImproveSkill = () => {

    const navigate = useNavigate();
    const handleNavigation = () => {
        const token = localStorage.getItem('student-token')
        if (token) {
            const decoded = jwtDecode(token);

            if (decoded?.user?.id) {
                navigate('/student/dashboard')
            }
            else {
                navigate('/login', { state: { user: 'student' } })
            }
        }
        else {
            navigate('/login', { state: { user: 'student' } })
        }

    }

    const dispatch = useDispatch();

    const {
        loadingHomeSixSecDataApi,
        HomeSixSecDataApiData,
        HomeSixSecDataApiError,

    } = useSelector(state => state?.MasterReducer);

    useEffect(() => {
        dispatch(getHomeSixSecData())

    }, []);

    useEffect(function () {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <section className="improve-skills-sec">
            <div className="container" data-aos="fade-up">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="skills-content">
                            <div className="skills-content-heading">
                                <h2>{HomeSixSecDataApiData?.home_section_six_title}</h2>
                                <p>
                                    {HomeSixSecDataApiData?.home_section_six_subtitle}
                                </p>
                            </div>
                            {/* <div className="skills-counter">
                                <div className="counter-box">
                                    <h5>
                                        <span className="counterUp">{HomeSixSecDataApiData?.home_section_six_counter_one_count}</span>k+
                                    </h5>
                                    <h4>{HomeSixSecDataApiData?.home_section_six_counter_one_name}</h4>
                                </div>
                                <div className="counter-box">
                                    <h5>
                                        <span className="counterUp">{HomeSixSecDataApiData?.home_section_six_counter_two_count}</span>k+
                                    </h5>
                                    <h4>{HomeSixSecDataApiData?.home_section_six_counter_two_name}</h4>
                                </div>
                                <div className="counter-box">
                                    <h5>
                                        <span className="counterUp">{HomeSixSecDataApiData?.home_section_six_counter_three_count}</span>k+
                                    </h5>
                                    <h4>{HomeSixSecDataApiData?.home_section_six_counter_three_name}</h4>
                                </div>
                            </div> */}

                            <div className="skills-counter">
                                {HomeSixSecDataApiData?.home_section_six_counter_one_count > 0 && (
                                    <div className="counter-box">
                                        <h5>
                                            <span className="counterUp">
                                                {HomeSixSecDataApiData.home_section_six_counter_one_count}
                                            </span>
                                            k+
                                        </h5>
                                        <h4>{HomeSixSecDataApiData?.home_section_six_counter_one_name}</h4>
                                    </div>
                                )}

                                {HomeSixSecDataApiData?.home_section_six_counter_two_count > 0 && (
                                    <div className="counter-box">
                                        <h5>
                                            <span className="counterUp">
                                                {HomeSixSecDataApiData.home_section_six_counter_two_count}
                                            </span>
                                            k+
                                        </h5>
                                        <h4>{HomeSixSecDataApiData?.home_section_six_counter_two_name}</h4>
                                    </div>
                                )}

                                {HomeSixSecDataApiData?.home_section_six_counter_three_count > 0 && (
                                    <div className="counter-box">
                                        <h5>
                                            <span className="counterUp">
                                                {HomeSixSecDataApiData.home_section_six_counter_three_count}
                                            </span>
                                            k+
                                        </h5>
                                        <h4>{HomeSixSecDataApiData?.home_section_six_counter_three_name}</h4>
                                    </div>
                                )}
                            </div>


                            <div className="join-btns">
                                <a onClick={handleNavigation} className="join">
                                    Join Now
                                </a>
                                <Link to="/find-tutor" className="find">Find Tutors</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5 d-flex align-items-center justify-content-center">
                        <div className="improve-img">
                            <img
                                src={`${host}${HomeSixSecDataApiData?.home_section_six_image}`}
                                className="img-fluid"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ImproveSkill